import { Card, EmptyState } from '@electricjs/arc';
import { useTranslation } from 'react-i18next';

type AssetImagesEmptyStateProps = {
  handleClick: () => void;
};

const AssetImagesEmptyState = ({ handleClick }: AssetImagesEmptyStateProps) => {
  const { t } = useTranslation('assets');

  return (
    <Card
      id="asset-images-empty-state-card"
      elevated
      width="100%"
      maxWidth="65rem"
      minWidth="25rem"
      my="8rem"
      onClick={handleClick}>
      <EmptyState
        title={t('assetImagesEmptyState.title')}
        subTitle={t('assetImagesEmptyState.subtitle')}
        icon="add-circle"
      />
    </Card>
  );
};

export default AssetImagesEmptyState;
